// app/store/store.ts
import { Action, ThunkDispatch, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { api } from './api';
import { dataSourcesApi } from './data-sources-api';
import authReducer, { initAuth } from './authSlice';
import { statsReducer, retryMiddleware } from './statsSlice';
import { DBReportReducer } from './reports-service-reducer';
import { isEqual } from "lodash";
import { DBUserReducer } from './users-service-reducer';
import platformSlice from './platformSlice';
import { DBLogsReducer } from './logs-service-reducer';
import { DBTrafficReportReducer } from './traffic-reports-service-reducer';
import { DBApiKeysReducer } from './api-keys-service-reducer';
import trackerData from './trackerData';
import { DBPaymentsReducer } from './payments-service-reducer';
import { DBFeedReducer } from './feeds-service-reducer';
import { DBFeedMetadataReducer } from './feed-metadata-service-reducer';
import { authMiddleware } from './auth-middleware';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [dataSourcesApi.reducerPath]: dataSourcesApi.reducer,
    auth: authReducer,
    stats: statsReducer,
    platform: platformSlice,
    DBReportReducer,
    DBUserReducer,
    DBLogsReducer,
    DBTrafficReportReducer,
    DBApiKeysReducer,
    DBPaymentsReducer,
    DBFeedReducer,
    DBFeedMetadataReducer,
    trackerData
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, dataSourcesApi.middleware, authMiddleware, retryMiddleware),
});
const dispatch = store.dispatch;

dispatch(initAuth());

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector) => useSelector(selector, isEqual);
